/*
 * Shopify Inbox (disabled — replaced by Tidio below)
 *
 * (function () {
 *   function getChatElements() {
 *     return {
 *       shopifyChat: document.querySelector('#ShopifyChat'),
 *       inboxChat: document.querySelector('inbox-online-store-chat'),
 *       chatButton: document.querySelector('.thb-chat-button'),
 *     };
 *   }
 *
 *   function updateChatState(isOpen) {
 *     const { shopifyChat, inboxChat, chatButton } = getChatElements();
 *     if (!shopifyChat || !inboxChat || !chatButton) return;
 *
 *     shopifyChat.setAttribute('is-open', isOpen.toString());
 *     inboxChat.style.setProperty('visibility', isOpen ? 'visible' : 'hidden', 'important');
 *     chatButton.classList.toggle('is-open', isOpen);
 *   }
 *
 *   function toggleChatBox(event) {
 *     if (event) event.preventDefault();
 *     const { shopifyChat, inboxChat, chatButton } = getChatElements();
 *
 *     if (!shopifyChat || !inboxChat) {
 *       console.error('Shopify chat widget not found.');
 *       return;
 *     }
 *     const isOpen = shopifyChat.getAttribute('is-open') === 'true';
 *
 *     if (!isOpen) {
 *       shopifyChat.setAttribute('is-open', 'true');
 *
 *       setTimeout(() => {
 *         const chatToggleButton = shopifyChat.shadowRoot?.querySelector('.chat-toggle');
 *         if (!chatToggleButton) {
 *           console.error('Chat toggle button not found.');
 *           shopifyChat.setAttribute('is-open', 'false');
 *           return;
 *         }
 *         chatToggleButton.click();
 *         if (inboxChat) {
 *           inboxChat.style.setProperty('visibility', 'visible', 'important');
 *         }
 *         if (chatButton) {
 *           chatButton.classList.add('is-open');
 *         }
 *       }, 50);
 *     } else {
 *       const closeButton = shopifyChat.shadowRoot?.querySelector('.chat-app--close-button');
 *       if (!closeButton) {
 *         console.error('Chat close button not found.');
 *         return;
 *       }
 *       closeButton.click();
 *       updateChatState(false);
 *     }
 *   }
 *
 *   document.addEventListener('click', function (event) {
 *     const { shopifyChat } = getChatElements();
 *     if (event.target.id === 'ShopifyChat' && shopifyChat?.getAttribute('is-open') === 'false') {
 *       updateChatState(false);
 *     }
 *   });
 *
 *   const chatObserver = new MutationObserver(function (mutations) {
 *     mutations.forEach(function (mutation) {
 *       if (mutation.addedNodes.length) {
 *         const element = mutation.addedNodes[0];
 *         if (element.id === 'ShopifyChat') {
 *           const { chatButton } = getChatElements();
 *           if (chatButton) {
 *             chatButton.classList.remove('hidden');
 *           }
 *           setTimeout(function () {
 *             if (element?.shadowRoot?.querySelector('.chat-app--is-open')) {
 *               updateChatState(true);
 *             }
 *           }, 100);
 *         }
 *       }
 *     });
 *   });
 *
 *   chatObserver.observe(document.body, { childList: true, subtree: true });
 *
 *   window.toggleChatBox = toggleChatBox;
 * })();
 */

/**
 * Tidio chat — open/close via custom buttons (e.g. mobile settings menu).
 * Exposes toggleChatBox globally for onclick handlers.
 *
 * Opening while Tidio is offline still toggles body.tidio-chat-open, which our CSS
 * uses to unhide a full-screen #tidio-chat overlay. With no widget UI, that overlay
 * swallows taps. Never open (and disable menu triggers) unless getStatus() is online.
 */
(function () {
  let isChatOpen = false;

  function getChatButton() {
    return document.querySelector('.thb-chat-button');
  }

  function getChatTriggers() {
    return document.querySelectorAll('[data-tidio-chat-trigger]');
  }

  function isTidioOnline(api) {
    if (!api || typeof api.getStatus !== 'function') return false;
    try {
      return api.getStatus() === 'online';
    } catch (e) {
      return false;
    }
  }

  function setChatOpenState(open) {
    isChatOpen = open;
    document.body.classList.toggle('tidio-chat-open', open);
    const chatButton = getChatButton();
    if (chatButton) {
      chatButton.classList.toggle('is-open', open);
    }
  }

  function syncChatTriggers(online) {
    getChatTriggers().forEach(function (el) {
      el.disabled = !online;
      el.setAttribute('aria-disabled', online ? 'false' : 'true');
    });

    if (!online && isChatOpen) {
      setChatOpenState(false);
      if (window.tidioChatApi && typeof window.tidioChatApi.close === 'function') {
        window.tidioChatApi.close();
      }
    }
  }

  function withTidioApi(callback) {
    if (window.tidioChatApi) {
      callback(window.tidioChatApi);
      return;
    }
    document.addEventListener(
      'tidioChat-ready',
      function () {
        callback(window.tidioChatApi);
      },
      { once: true },
    );
  }

  function bindTidioEvents(api) {
    api.on('open', function () {
      if (!isTidioOnline(api)) {
        api.close();
        setChatOpenState(false);
        return;
      }
      setChatOpenState(true);
    });
    api.on('close', function () {
      setChatOpenState(false);
    });
    if (typeof api.on === 'function') {
      api.on('setStatus', function () {
        syncChatTriggers(isTidioOnline(api));
      });
    }
  }

  function initTidio(api) {
    bindTidioEvents(api);
    syncChatTriggers(isTidioOnline(api));
    const chatButton = getChatButton();
    if (chatButton) {
      chatButton.classList.remove('hidden');
    }
  }

  function toggleChatBox(event) {
    if (event) event.preventDefault();

    withTidioApi(function (api) {
      const online = isTidioOnline(api);
      syncChatTriggers(online);

      if (!online) {
        setChatOpenState(false);
        return;
      }

      if (isChatOpen) {
        api.close();
        setChatOpenState(false);
        return;
      }

      setChatOpenState(true);
      api.open();
    });
  }

  syncChatTriggers(false);
  withTidioApi(initTidio);

  window.toggleChatBox = toggleChatBox;
})();
